import React, { Component } from 'react';
import Body from "./Body";
import Footer from "./Footer";

class App extends Component {
  render() {
    return (
      <div className="content">
        <Body />
        <Footer />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js